import React from 'react';
import styles from './ButtonWithIcon.module.scss';
import Button from './Button';

type Props = {
  label: string;
  Icon?: React.ElementType;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  type?: 'button' | 'submit';
  dataCy?: string;
  backgroundColor?: string;
  textColor?: string;
  borderColor?: string;
  hoverBackgroundColor?: string;
  activeBackgroundColor?: string;
};

const ButtonWithIcon = ({
  label,
  Icon,
  onClick,
  disabled,
  type,
  dataCy,
  backgroundColor,
  textColor,
  borderColor,
  hoverBackgroundColor,
  activeBackgroundColor,
}: Props) => {
  return (
    <Button
      onClick={onClick}
      type={type}
      disabled={disabled}
      dataCy={dataCy}
      backgroundColor={backgroundColor}
      textColor={textColor}
      borderColor={borderColor}
      hoverBackgroundColor={hoverBackgroundColor}
      activeBackgroundColor={activeBackgroundColor}
    >
      <div className={styles.content}>
        <span className={styles.label}>{label}</span>
        {Icon && <Icon className={styles.icon} fontSize="small" />}
      </div>
    </Button>
  );
};

export default ButtonWithIcon;
